import SEO from "@/components/SEO";
import { faqSchema } from "@/components/SEO";
import Layout from "@/components/Layout";
import HeroSection from "@/components/HeroSection";
import { lazy, Suspense } from "react";

// Lazy load below-the-fold sections to reduce initial bundle
const FeaturedEpisodes = lazy(() => import("@/components/FeaturedEpisodes"));
const HostsSection = lazy(() => import("@/components/HostsSection"));
const SocialProof = lazy(() => import("@/components/SocialProof"));
const SubscribeCTA = lazy(() => import("@/components/SubscribeCTA"));

const Index = () => {
  return (
    <>
      <SEO
        title="The Founders Lounge | For Founders, By Founders"
        description="Real conversations with successful entrepreneurs. Unfiltered insights and proven strategies behind thriving businesses."
        keywords="The Founders Lounge, Founders Lounge podcast, entrepreneur podcast Texas, startup founder interviews, business podcast for founders, CEO interviews, founder stories, entrepreneurship podcast, small business podcast, startup advice, entrepreneur success stories, business growth strategies, Texas entrepreneur podcast, founder journey, real entrepreneur conversations"
        canonicalUrl="/"
        structuredData={[faqSchema]}
      />
      <Layout>
        <HeroSection />
        <Suspense fallback={<div className="min-h-[600px] bg-background" />}>
          <div className="content-lazy">
            <FeaturedEpisodes />
          </div>
          <div className="content-lazy">
            <HostsSection />
          </div>
          <div className="content-lazy">
            <SocialProof />
          </div>
          <div className="content-lazy">
            <SubscribeCTA />
          </div>
        </Suspense>
      </Layout>
    </>
  );
};

export default Index;
